var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"page-sizes":_vm.paginations.pageSizes,"page-size":_vm.pageSize,"layout":_vm.paginations.layout,"total":_vm.pageTotal,"current-page":_vm.currentPage},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }